import { dataToggle } from "../utils/toggle-dataset"
import { $Q, $Qll } from "../utils/query-selector"
import api from "../services/api"
import { stringToHTML } from "../utils/to-html"
import { setQuantity } from "../utils/input-quantity"
import { submitForm } from "./cart"
import { loadSubscriptionForms, toggleSubscriptionInfo } from "../components/subscription-form";
import { onChangeItemProduct } from "./quantity-change"

/**
* Performs the opening and closing of the modal.
* Render the inside of the product for the modal
* @author Andres Briñez
*/

/**
* Function that opens and closes the modal
*/

export const openCloseModal = (isMount = false) => {
  const controls = $Qll('.quickshop-toggle-js');
  const modal = $Q('#product-modal-js');

  controls.forEach((control) => {
    if (isMount && control.type === 'button') {
      return null;
    }

    return control.addEventListener(
      'click',
      () => {
        dataToggle(modal, true);
      },
    );
  })
}

function datalayerModal() {
  const button = document.querySelectorAll('.btn-add-to-cart');

  button.forEach((element) => {
    element.addEventListener('click', () => {

      fbq('track', 'AddToCart', {
        name: "peaudouce - Product",
        properties: {
          id: element.dataset.productid, // replace by value
          name: element.dataset.productname, // replace by value
          price: element.dataset.productprice, // replace by value
          category: element.dataset.productcategory, // replace by value
          subCategory: "", // replace by value
          currency: "EUR", // replace by value
          description: element.dataset.productdescription, // replace by value
          imageUrl: element.dataset.productimage, // replace by value
          url: element.dataset.producturl, // replace by value
        },
      });
    })
  });
}

/**
* Calls the functions:
* {} To capture the variants.
* {} Makes the modification of the amounts
* @param {object} newSection Html component to render
*/

function updateSection(newSection, parent) {
  const section = $Q('.modal__information', parent);

  section.innerHTML = newSection.innerHTML;

  loadSubscriptionForms(true, section);
  toggleSubscriptionInfo();
  setQuantity(section);
  submitForm($Q(".add-cart-js", section), true);
  datalayerModal();
  onChangeItemProduct();
}

/**
* Build the products url. Call the {shopifySectionByUrl}
* function to return the HTML structure with the handle element.
* @param {object} nodeHandle trigger node with its data-handle
*/

async function dataHandle(nodeHandle) {
  const dataSet = nodeHandle.dataset.handle;
  const dataHandle = `/products/${dataSet}`;
  const parent = $Q('#product-modal-js');

  $Q('.modal__information', parent).innerHTML = '<div class="spinner-container"><div class="spinner"></div></div>';
  const htmlResponse = await api.shopifySectionByUrl(dataHandle, 'product-modal');
  const query = $Q(".product-modal", stringToHTML(htmlResponse));

  updateSection(query, parent);
}

/**
* Performs the search for the elements that activate the rendering
* @param {String} node activator button
* @return Element click event fired
*/

function searchProductHandle(node) {
  return $Qll(node).forEach((element) => {

    element.addEventListener(
      'click', () => {
        dataHandle(element);
      },
   )
  });
}

/**
* Function that renders the elements of the product modal
*/

export const renderElements = () => {
  searchProductHandle('.quick-shop-elements')
}

/**
 * Single function to close Quick Shop Modal with virtual click
 * @returns null -  stop call
 */
export const singleCloseQuickModal = () => {
  const modalQuickShop = $Q('#product-modal-js');

  if (!modalQuickShop) return;

  if (modalQuickShop.dataset.active === 'true') {
    $Q('.quickshop-toggle-js', modalQuickShop).click()
  }
}
